import api from "./api";

export const LeaveAPI = {
  listTypes: () => api("/leave/types"),
  listMyRequests: () => api("/leave/my"),
  listMyAllowances: (year) =>
    api(`/leave/allowances/me${year ? `?year=${year}` : ""}`),
  createRequest: (payload) =>
    api("/leave/requests", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  listAllRequests: () => api("/leave/requests"),
  approveRequest: (id) =>
    api(`/leave/requests/${id}/approve`, {
      method: "POST",
      body: JSON.stringify({}),
    }),
  rejectRequest: (id, rejection_reason) =>
    api(`/leave/requests/${id}/reject`, {
      method: "POST",
      body: JSON.stringify({ rejection_reason }),
    }),
  cancelRequest: (id) =>
    api(`/leave/requests/${id}/cancel`, {
      method: "POST",
      body: JSON.stringify({}),
    }),
  adminAllowances: (userId, year) =>
    api(`/leave/admin/allowances?user_id=${userId}&year=${year}`),

  saveAllowance: (payload) =>
  api(`/leave/admin/allowances`, {
    method: "POST",
    body: JSON.stringify(payload),
  }),
};

